export default __webpack_public_path__ + "static/media/discover.6ca9ecfe.png";